import { createContext } from "react";
const configContext = createContext({
  context: {}
});
export {
  configContext
};
//# sourceMappingURL=context.js.map
